import { setTerms } from './helpers';

export const setExcludeWords = setTerms('description_exclude');
